const legacyBase = '/admin/communications';
const moduleBase = '/modules/clc-communications';

export function communicationsDestination(pathname) {
  const suffix = pathname.slice(legacyBase.length);
  if (/^\/inbox(?:\/|$)/.test(suffix)) return null;
  if (!suffix || suffix === '/') return `${moduleBase}/queue`;
  for (const [oldPath, newPath] of [
    ['/types', '/foundation/types'],
    ['/fields', '/foundation/field-catalog'],
    ['/validate', '/foundation/validate-context'],
  ]) {
    if (suffix === oldPath || suffix.startsWith(`${oldPath}/`)) {
      return `${moduleBase}${newPath}${suffix.slice(oldPath.length)}`;
    }
  }
  return `${moduleBase}${suffix}`;
}
